import React from 'react';
import ContentLoader from 'react-content-loader';

const FiltersSkeleton = () => (
  <ContentLoader
    speed={2}
    width={268}
    height={96}
    viewBox="0 0 300 96"
    foregroundColor="#ecebeb"
    backgroundColor="#f3f3f3"
    data-testid="filters-skeleton"
  >
    <rect x="0" y="16" rx="4" ry="4" width="160" height="20" />
    <rect x="16" y="56" rx="4" ry="4" width="268" height="20" />
  </ContentLoader>
);

export default FiltersSkeleton;
